import { __decorate } from "tslib";
import VueMarkdown from 'vue-markdown';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MySelect from '@/components/MySelect.vue';
const featModule = namespace('feats');
let CharacterBuilderClassASI = class CharacterBuilderClassASI extends Vue {
    constructor() {
        super(...arguments);
        this.asiOptions = [
            'Strength',
            'Dexterity',
            'Constitution',
            'Intelligence',
            'Wisdom',
            'Charisma'
        ];
    }
    created() {
        this.fetchFeats();
    }
    get asi() {
        return this.myClass.abilityScoreImprovements[this.index];
    }
    get selectedAbilityScores() {
        if (!this.isASI(this.asi) || this.asi.abilitiesIncreased.length === 0)
            return [];
        const first = this.asi.abilitiesIncreased[0];
        return first.value === 2 ? [first.name, first.name] : this.asi.abilitiesIncreased.map(({ name }) => name);
    }
    get featOptions() {
        return this.feats.map(({ name }) => name);
    }
    get featText() {
        if (!this.isFeat(this.asi))
            return '';
        const asiName = this.asi.name;
        const featData = this.feats.find(({ name }) => name === asiName);
        return featData ? featData.text : '';
    }
    isASI(asi) {
        return asi && asi.type === 'Ability Score Improvement';
    }
    isFeat(asi) {
        return asi && asi.type === 'Feat';
    }
    handleChangeType(type) {
        const asi = type === 'Feat' ? { type, name: '' } : { type, abilitiesIncreased: [] };
        this.$emit('updateASI', asi);
    }
    handleUpdateASI(name, index) {
        if (!this.isASI(this.asi))
            return;
        const otherAbility = this.asi.abilitiesIncreased[index ? 0 : 1];
        let abilitiesIncreased = this.asi.abilitiesIncreased;
        if (otherAbility && name === otherAbility.name)
            abilitiesIncreased = [{ name, value: 2 }];
        else
            abilitiesIncreased[index] = { name, value: 1 };
        this.$emit('updateASI', { type: 'Ability Score Improvement', abilitiesIncreased });
    }
    handleUpdateFeat(name) {
        this.$emit('updateASI', { type: 'Feat', name });
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderClassASI.prototype, "myClass", void 0);
__decorate([
    Prop(Number)
], CharacterBuilderClassASI.prototype, "index", void 0);
__decorate([
    featModule.State
], CharacterBuilderClassASI.prototype, "feats", void 0);
__decorate([
    featModule.Action
], CharacterBuilderClassASI.prototype, "fetchFeats", void 0);
CharacterBuilderClassASI = __decorate([
    Component({
        components: {
            VueMarkdown,
            MySelect
        }
    })
], CharacterBuilderClassASI);
export default CharacterBuilderClassASI;
